export default "__VITE_ASSET__DYoBr1Ie__"